import React from "react";

export const LazyTermSheet = React.lazy(() =>
  import("@toorak/op-web-common-service").then((module) => ({
    default: module.TermSheetV2,
  }))
);

export const LazyBudgetReview = React.lazy(() =>
  import("@toorak/budget-review-module").then((module) => ({
    default: module.BudgetReviewWrapperSDK,
  }))
);

export const LazyBudgetReconcile = React.lazy(() =>
  import("@toorak/budget-reconcile-sdk").then((module) => ({
    default: module.InspectionBudget,
  }))
);

